import { EmojiFamilyKeys } from "RoosterReact/rooster-react-amd";
import * as Resources from "WorkItemTracking/Scripts/Resources/TFS.Resources.WorkItemTracking.RoosterJs.Emoji";
import * as WITResources from "WorkItemTracking/Scripts/Resources/TFS.Resources.WorkItemTracking";

export const EmojiLocaleStrings = {
    // Emoji families
    [EmojiFamilyKeys.Activities]: Resources.EmojiFamily_Activities,
    [EmojiFamilyKeys.Food]: Resources.EmojiFamily_Food,
    [EmojiFamilyKeys.Nature]: Resources.EmojiFamily_Nature,
    [EmojiFamilyKeys.Objects]: Resources.EmojiFamily_Objects,
    [EmojiFamilyKeys.People]: Resources.EmojiFamily_People,
    [EmojiFamilyKeys.Symbols]: Resources.EmojiFamily_Symbols,
    [EmojiFamilyKeys.Travel]: Resources.EmojiFamily_Travel,

    // Emoji status bar
    emjDNoSuggetions: WITResources.NoSuggestionsFound,

    // Emoji names
    emjDMore: Resources.Emoji_More,
    emjD0270a: Resources.Emoji_0270a,
    emjD0270b: Resources.Emoji_0270b,
    emjD0270c: Resources.Emoji_0270c,
    emjD02764: Resources.Emoji_02764,
    emjD1f440: Resources.Emoji_1f440,
    emjD1f442: Resources.Emoji_1f442,
    emjD1f443: Resources.Emoji_1f443,
    emjD1f444: Resources.Emoji_1f444,
    emjD1f445: Resources.Emoji_1f445,
    emjD1f446: Resources.Emoji_1f446,
    emjD1f447: Resources.Emoji_1f447,
    emjD1f448: Resources.Emoji_1f448,
    emjD1f449: Resources.Emoji_1f449,
    emjD1f44a: Resources.Emoji_1f44a,
    emjD1f44b: Resources.Emoji_1f44b,
    emjD1f44c: Resources.Emoji_1f44c,
    emjD1f44d: Resources.Emoji_1f44d,
    emjD1f44e: Resources.Emoji_1f44e,
    emjD1f44f: Resources.Emoji_1f44f,
    emjD1f450: Resources.Emoji_1f450,
    emjD1f590: Resources.Emoji_1f590,
    emjD1f595: Resources.Emoji_1f595,
    emjD1f596: Resources.Emoji_1f596,
    emjD1f464: Resources.Emoji_1f464,
    emjD1f466: Resources.Emoji_1f466,
    emjD1f467: Resources.Emoji_1f467,
    emjD1f468: Resources.Emoji_1f468,
    emjD1f469: Resources.Emoji_1f469,
    emjD1f46a: Resources.Emoji_1f46a,
    emjD1f46b: Resources.Emoji_1f46b,
    emjD1f46e: Resources.Emoji_1f46e,
    emjD1f46f: Resources.Emoji_1f46f,
    emjD1f470: Resources.Emoji_1f470,
    emjD1f471: Resources.Emoji_1f471,
    emjD1f472: Resources.Emoji_1f472,
    emjD1f473: Resources.Emoji_1f473,
    emjD1f474: Resources.Emoji_1f474,
    emjD1f475: Resources.Emoji_1f475,
    emjD1f476: Resources.Emoji_1f476,
    emjD1f477: Resources.Emoji_1f477,
    emjD1f481: Resources.Emoji_1f481,
    emjD1f482: Resources.Emoji_1f482,
    emjD1f48b: Resources.Emoji_1f48b,
    emjD1f493: Resources.Emoji_1f493,
    emjD1f494: Resources.Emoji_1f494,
    emjD1f495: Resources.Emoji_1f495,
    emjD1f496: Resources.Emoji_1f496,
    emjD1f497: Resources.Emoji_1f497,
    emjD1f498: Resources.Emoji_1f498,
    emjD1f499: Resources.Emoji_1f499,
    emjD1f49a: Resources.Emoji_1f49a,
    emjD1f49b: Resources.Emoji_1f49b,
    emjD1f49c: Resources.Emoji_1f49c,
    emjD1f49d: Resources.Emoji_1f49d,
    emjD1f49e: Resources.Emoji_1f49e,
    emjD1f49f: Resources.Emoji_1f49f,
    emjD1f601: Resources.Emoji_1f601,
    emjD1f602: Resources.Emoji_1f602,
    emjD1f603: Resources.Emoji_1f603,
    emjD1f604: Resources.Emoji_1f604,
    emjD1f605: Resources.Emoji_1f605,
    emjD1f606: Resources.Emoji_1f606,
    emjD1f607: Resources.Emoji_1f607,
    emjD1f608: Resources.Emoji_1f608,
    emjD1f609: Resources.Emoji_1f609,
    emjD1f60a: Resources.Emoji_1f60a,
    emjD1f60b: Resources.Emoji_1f60b,
    emjD1f60c: Resources.Emoji_1f60c,
    emjD1f60d: Resources.Emoji_1f60d,
    emjD1f60e: Resources.Emoji_1f60e,
    emjD1f60f: Resources.Emoji_1f60f,
    emjD1f610: Resources.Emoji_1f610,
    emjD1f612: Resources.Emoji_1f612,
    emjD1f613: Resources.Emoji_1f613,
    emjD1f614: Resources.Emoji_1f614,
    emjD1f616: Resources.Emoji_1f616,
    emjD1f618: Resources.Emoji_1f618,
    emjD1f61a: Resources.Emoji_1f61a,
    emjD1f61c: Resources.Emoji_1f61c,
    emjD1f61d: Resources.Emoji_1f61d,
    emjD1f61e: Resources.Emoji_1f61e,
    emjD1f620: Resources.Emoji_1f620,
    emjD1f621: Resources.Emoji_1f621,
    emjD1f622: Resources.Emoji_1f622,
    emjD1f623: Resources.Emoji_1f623,
    emjD1f624: Resources.Emoji_1f624,
    emjD1f625: Resources.Emoji_1f625,
    emjD1f628: Resources.Emoji_1f628,
    emjD1f629: Resources.Emoji_1f629,
    emjD1f62a: Resources.Emoji_1f62a,
    emjD1f62b: Resources.Emoji_1f62b,
    emjD1f62d: Resources.Emoji_1f62d,
    emjD1f630: Resources.Emoji_1f630,
    emjD1f631: Resources.Emoji_1f631,
    emjD1f632: Resources.Emoji_1f632,
    emjD1f633: Resources.Emoji_1f633,
    emjD1f635: Resources.Emoji_1f635,
    emjD1f636: Resources.Emoji_1f636,
    emjD1f637: Resources.Emoji_1f637,
    emjD1f645: Resources.Emoji_1f645,
    emjD1f646: Resources.Emoji_1f646,
    emjD1f647: Resources.Emoji_1f647,
    emjD1f648: Resources.Emoji_1f648,
    emjD1f649: Resources.Emoji_1f649,
    emjD1f641: Resources.Emoji_1f641,
    emjD1f642: Resources.Emoji_1f642,
    emjD1f64a: Resources.Emoji_1f64a,
    emjD1f64b: Resources.Emoji_1f64b,
    emjD1f64c: Resources.Emoji_1f64c,
    emjD1f64d: Resources.Emoji_1f64d,
    emjD1f64e: Resources.Emoji_1f64e,
    emjD1f64f: Resources.Emoji_1f64f,
    emjD02600: Resources.Emoji_02600,
    emjD02601: Resources.Emoji_02601,
    emjD02614: Resources.Emoji_02614,
    emjD0267b: Resources.Emoji_0267b,
    emjD026c4: Resources.Emoji_026c4,
    emjD026c5: Resources.Emoji_026c5,
    emjD02728: Resources.Emoji_02728,
    emjD02733: Resources.Emoji_02733,
    emjD02734: Resources.Emoji_02734,
    emjD02744: Resources.Emoji_02744,
    emjD02747: Resources.Emoji_02747,
    emjD02b50: Resources.Emoji_02b50,
    emjD1f300: Resources.Emoji_1f300,
    emjD1f301: Resources.Emoji_1f301,
    emjD1f302: Resources.Emoji_1f302,
    emjD1f303: Resources.Emoji_1f303,
    emjD1f304: Resources.Emoji_1f304,
    emjD1f305: Resources.Emoji_1f305,
    emjD1f306: Resources.Emoji_1f306,
    emjD1f307: Resources.Emoji_1f307,
    emjD1f308: Resources.Emoji_1f308,
    emjD1f309: Resources.Emoji_1f309,
    emjD1f30a: Resources.Emoji_1f30a,
    emjD1f30b: Resources.Emoji_1f30b,
    emjD1f30c: Resources.Emoji_1f30c,
    emjD1f311: Resources.Emoji_1f311,
    emjD1f313: Resources.Emoji_1f313,
    emjD1f314: Resources.Emoji_1f314,
    emjD1f315: Resources.Emoji_1f315,
    emjD1f319: Resources.Emoji_1f319,
    emjD1f31b: Resources.Emoji_1f31b,
    emjD1f31f: Resources.Emoji_1f31f,
    emjD1f320: Resources.Emoji_1f320,
    emjD1f330: Resources.Emoji_1f330,
    emjD1f331: Resources.Emoji_1f331,
    emjD1f334: Resources.Emoji_1f334,
    emjD1f335: Resources.Emoji_1f335,
    emjD1f337: Resources.Emoji_1f337,
    emjD1f338: Resources.Emoji_1f338,
    emjD1f339: Resources.Emoji_1f339,
    emjD1f33a: Resources.Emoji_1f33a,
    emjD1f33b: Resources.Emoji_1f33b,
    emjD1f33c: Resources.Emoji_1f33c,
    emjD1f33d: Resources.Emoji_1f33d,
    emjD1f33e: Resources.Emoji_1f33e,
    emjD1f33f: Resources.Emoji_1f33f,
    emjD1f340: Resources.Emoji_1f340,
    emjD1f341: Resources.Emoji_1f341,
    emjD1f342: Resources.Emoji_1f342,
    emjD1f343: Resources.Emoji_1f343,
    emjD1f344: Resources.Emoji_1f344,
    emjD1f40c: Resources.Emoji_1f40c,
    emjD1f40d: Resources.Emoji_1f40d,
    emjD1f40e: Resources.Emoji_1f40e,
    emjD1f411: Resources.Emoji_1f411,
    emjD1f412: Resources.Emoji_1f412,
    emjD1f414: Resources.Emoji_1f414,
    emjD1f417: Resources.Emoji_1f417,
    emjD1f418: Resources.Emoji_1f418,
    emjD1f419: Resources.Emoji_1f419,
    emjD1f41a: Resources.Emoji_1f41a,
    emjD1f41b: Resources.Emoji_1f41b,
    emjD1f41c: Resources.Emoji_1f41c,
    emjD1f41d: Resources.Emoji_1f41d,
    emjD1f41e: Resources.Emoji_1f41e,
    emjD1f41f: Resources.Emoji_1f41f,
    emjD1f420: Resources.Emoji_1f420,
    emjD1f421: Resources.Emoji_1f421,
    emjD1f422: Resources.Emoji_1f422,
    emjD1f423: Resources.Emoji_1f423,
    emjD1f424: Resources.Emoji_1f424,
    emjD1f425: Resources.Emoji_1f425,
    emjD1f426: Resources.Emoji_1f426,
    emjD1f427: Resources.Emoji_1f427,
    emjD1f428: Resources.Emoji_1f428,
    emjD1f429: Resources.Emoji_1f429,
    emjD1f42b: Resources.Emoji_1f42b,
    emjD1f42c: Resources.Emoji_1f42c,
    emjD1f42d: Resources.Emoji_1f42d,
    emjD1f42e: Resources.Emoji_1f42e,
    emjD1f42f: Resources.Emoji_1f42f,
    emjD1f430: Resources.Emoji_1f430,
    emjD1f431: Resources.Emoji_1f431,
    emjD1f432: Resources.Emoji_1f432,
    emjD1f433: Resources.Emoji_1f433,
    emjD1f434: Resources.Emoji_1f434,
    emjD1f435: Resources.Emoji_1f435,
    emjD1f436: Resources.Emoji_1f436,
    emjD1f437: Resources.Emoji_1f437,
    emjD1f438: Resources.Emoji_1f438,
    emjD1f439: Resources.Emoji_1f439,
    emjD1f43a: Resources.Emoji_1f43a,
    emjD1f43b: Resources.Emoji_1f43b,
    emjD1f43c: Resources.Emoji_1f43c,
    emjD1f43d: Resources.Emoji_1f43d,
    emjD1f43e: Resources.Emoji_1f43e,
    emjD1f638: Resources.Emoji_1f638,
    emjD1f639: Resources.Emoji_1f639,
    emjD1f63a: Resources.Emoji_1f63a,
    emjD1f63b: Resources.Emoji_1f63b,
    emjD1f63c: Resources.Emoji_1f63c,
    emjD1f63d: Resources.Emoji_1f63d,
    emjD1f63e: Resources.Emoji_1f63e,
    emjD1f63f: Resources.Emoji_1f63f,
    emjD1f640: Resources.Emoji_1f640,
    emjD0260e: Resources.Emoji_0260e,
    emjD026bd: Resources.Emoji_026bd,
    emjD026be: Resources.Emoji_026be,
    emjD1f004: Resources.Emoji_1f004,
    emjD1f380: Resources.Emoji_1f380,
    emjD1f381: Resources.Emoji_1f381,
    emjD1f382: Resources.Emoji_1f382,
    emjD1f383: Resources.Emoji_1f383,
    emjD1f384: Resources.Emoji_1f384,
    emjD1f385: Resources.Emoji_1f385,
    emjD1f386: Resources.Emoji_1f386,
    emjD1f387: Resources.Emoji_1f387,
    emjD1f388: Resources.Emoji_1f388,
    emjD1f389: Resources.Emoji_1f389,
    emjD1f38a: Resources.Emoji_1f38a,
    emjD1f38b: Resources.Emoji_1f38b,
    emjD1f38c: Resources.Emoji_1f38c,
    emjD1f38d: Resources.Emoji_1f38d,
    emjD1f38e: Resources.Emoji_1f38e,
    emjD1f38f: Resources.Emoji_1f38f,
    emjD1f390: Resources.Emoji_1f390,
    emjD1f391: Resources.Emoji_1f391,
    emjD1f392: Resources.Emoji_1f392,
    emjD1f393: Resources.Emoji_1f393,
    emjD1f3a0: Resources.Emoji_1f3a0,
    emjD1f3a1: Resources.Emoji_1f3a1,
    emjD1f3a2: Resources.Emoji_1f3a2,
    emjD1f3a3: Resources.Emoji_1f3a3,
    emjD1f3a4: Resources.Emoji_1f3a4,
    emjD1f3a5: Resources.Emoji_1f3a5,
    emjD1f3a6: Resources.Emoji_1f3a6,
    emjD1f3a7: Resources.Emoji_1f3a7,
    emjD1f3a8: Resources.Emoji_1f3a8,
    emjD1f3a9: Resources.Emoji_1f3a9,
    emjD1f3aa: Resources.Emoji_1f3aa,
    emjD1f3ab: Resources.Emoji_1f3ab,
    emjD1f3ac: Resources.Emoji_1f3ac,
    emjD1f3ad: Resources.Emoji_1f3ad,
    emjD1f3ae: Resources.Emoji_1f3ae,
    emjD1f3af: Resources.Emoji_1f3af,
    emjD1f3b0: Resources.Emoji_1f3b0,
    emjD1f3b1: Resources.Emoji_1f3b1,
    emjD1f3b2: Resources.Emoji_1f3b2,
    emjD1f3b3: Resources.Emoji_1f3b3,
    emjD1f3b4: Resources.Emoji_1f3b4,
    emjD1f3b5: Resources.Emoji_1f3b5,
    emjD1f3b6: Resources.Emoji_1f3b6,
    emjD1f3b7: Resources.Emoji_1f3b7,
    emjD1f3b8: Resources.Emoji_1f3b8,
    emjD1f3b9: Resources.Emoji_1f3b9,
    emjD1f3ba: Resources.Emoji_1f3ba,
    emjD1f3bb: Resources.Emoji_1f3bb,
    emjD1f3bc: Resources.Emoji_1f3bc,
    emjD1f3bd: Resources.Emoji_1f3bd,
    emjD1f3be: Resources.Emoji_1f3be,
    emjD1f3bf: Resources.Emoji_1f3bf,
    emjD1f3c0: Resources.Emoji_1f3c0,
    emjD1f3c1: Resources.Emoji_1f3c1,
    emjD1f3c2: Resources.Emoji_1f3c2,
    emjD1f3c3: Resources.Emoji_1f3c3,
    emjD1f3c4: Resources.Emoji_1f3c4,
    emjD1f3c6: Resources.Emoji_1f3c6,
    emjD1f3c8: Resources.Emoji_1f3c8,
    emjD1f3ca: Resources.Emoji_1f3ca,
    emjD1f478: Resources.Emoji_1f478,
    emjD1f479: Resources.Emoji_1f479,
    emjD1f47a: Resources.Emoji_1f47a,
    emjD1f47b: Resources.Emoji_1f47b,
    emjD1f47c: Resources.Emoji_1f47c,
    emjD1f47d: Resources.Emoji_1f47d,
    emjD1f47e: Resources.Emoji_1f47e,
    emjD1f47f: Resources.Emoji_1f47f,
    emjD1f480: Resources.Emoji_1f480,
    emjD1f483: Resources.Emoji_1f483,
    emjD1f484: Resources.Emoji_1f484,
    emjD1f485: Resources.Emoji_1f485,
    emjD1f486: Resources.Emoji_1f486,
    emjD1f487: Resources.Emoji_1f487,
    emjD1f488: Resources.Emoji_1f488,
    emjD1f489: Resources.Emoji_1f489,
    emjD1f48a: Resources.Emoji_1f48a,
    emjD1f48c: Resources.Emoji_1f48c,
    emjD1f48d: Resources.Emoji_1f48d,
    emjD1f48e: Resources.Emoji_1f48e,
    emjD1f48f: Resources.Emoji_1f48f,
    emjD1f490: Resources.Emoji_1f490,
    emjD1f491: Resources.Emoji_1f491,
    emjD1f492: Resources.Emoji_1f492,
    emjD1f4f7: Resources.Emoji_1f4f7,
    emjD1f4f9: Resources.Emoji_1f4f9,
    emjD1f4fa: Resources.Emoji_1f4fa,
    emjD1f4fb: Resources.Emoji_1f4fb,
    emjD1f4fc: Resources.Emoji_1f4fc,
    emjD02615: Resources.Emoji_02615,
    emjD02702: Resources.Emoji_02702,
    emjD02709: Resources.Emoji_02709,
    emjD0270f: Resources.Emoji_0270f,
    emjD02712: Resources.Emoji_02712,
    emjD1f345: Resources.Emoji_1f345,
    emjD1f346: Resources.Emoji_1f346,
    emjD1f347: Resources.Emoji_1f347,
    emjD1f348: Resources.Emoji_1f348,
    emjD1f349: Resources.Emoji_1f349,
    emjD1f34a: Resources.Emoji_1f34a,
    emjD1f34c: Resources.Emoji_1f34c,
    emjD1f34d: Resources.Emoji_1f34d,
    emjD1f34e: Resources.Emoji_1f34e,
    emjD1f34f: Resources.Emoji_1f34f,
    emjD1f351: Resources.Emoji_1f351,
    emjD1f352: Resources.Emoji_1f352,
    emjD1f353: Resources.Emoji_1f353,
    emjD1f354: Resources.Emoji_1f354,
    emjD1f355: Resources.Emoji_1f355,
    emjD1f356: Resources.Emoji_1f356,
    emjD1f357: Resources.Emoji_1f357,
    emjD1f358: Resources.Emoji_1f358,
    emjD1f359: Resources.Emoji_1f359,
    emjD1f35a: Resources.Emoji_1f35a,
    emjD1f35b: Resources.Emoji_1f35b,
    emjD1f35c: Resources.Emoji_1f35c,
    emjD1f35d: Resources.Emoji_1f35d,
    emjD1f35e: Resources.Emoji_1f35e,
    emjD1f35f: Resources.Emoji_1f35f,
    emjD1f360: Resources.Emoji_1f360,
    emjD1f361: Resources.Emoji_1f361,
    emjD1f362: Resources.Emoji_1f362,
    emjD1f363: Resources.Emoji_1f363,
    emjD1f364: Resources.Emoji_1f364,
    emjD1f365: Resources.Emoji_1f365,
    emjD1f366: Resources.Emoji_1f366,
    emjD1f367: Resources.Emoji_1f367,
    emjD1f368: Resources.Emoji_1f368,
    emjD1f369: Resources.Emoji_1f369,
    emjD1f36a: Resources.Emoji_1f36a,
    emjD1f36b: Resources.Emoji_1f36b,
    emjD1f36c: Resources.Emoji_1f36c,
    emjD1f36d: Resources.Emoji_1f36d,
    emjD1f36e: Resources.Emoji_1f36e,
    emjD1f36f: Resources.Emoji_1f36f,
    emjD1f370: Resources.Emoji_1f370,
    emjD1f371: Resources.Emoji_1f371,
    emjD1f372: Resources.Emoji_1f372,
    emjD1f373: Resources.Emoji_1f373,
    emjD1f374: Resources.Emoji_1f374,
    emjD1f375: Resources.Emoji_1f375,
    emjD1f376: Resources.Emoji_1f376,
    emjD1f377: Resources.Emoji_1f377,
    emjD1f378: Resources.Emoji_1f378,
    emjD1f379: Resources.Emoji_1f379,
    emjD1f37a: Resources.Emoji_1f37a,
    emjD1f37b: Resources.Emoji_1f37b,
    emjD1f451: Resources.Emoji_1f451,
    emjD1f452: Resources.Emoji_1f452,
    emjD1f453: Resources.Emoji_1f453,
    emjD1f454: Resources.Emoji_1f454,
    emjD1f455: Resources.Emoji_1f455,
    emjD1f456: Resources.Emoji_1f456,
    emjD1f457: Resources.Emoji_1f457,
    emjD1f458: Resources.Emoji_1f458,
    emjD1f459: Resources.Emoji_1f459,
    emjD1f45a: Resources.Emoji_1f45a,
    emjD1f45b: Resources.Emoji_1f45b,
    emjD1f45c: Resources.Emoji_1f45c,
    emjD1f45d: Resources.Emoji_1f45d,
    emjD1f45e: Resources.Emoji_1f45e,
    emjD1f45f: Resources.Emoji_1f45f,
    emjD1f460: Resources.Emoji_1f460,
    emjD1f461: Resources.Emoji_1f461,
    emjD1f462: Resources.Emoji_1f462,
    emjD1f463: Resources.Emoji_1f463,
    emjD1f4ba: Resources.Emoji_1f4ba,
    emjD1f4bb: Resources.Emoji_1f4bb,
    emjD1f4bc: Resources.Emoji_1f4bc,
    emjD1f4bd: Resources.Emoji_1f4bd,
    emjD1f4be: Resources.Emoji_1f4be,
    emjD1f4bf: Resources.Emoji_1f4bf,
    emjD1f4c0: Resources.Emoji_1f4c0,
    emjD1f4c1: Resources.Emoji_1f4c1,
    emjD1f4c2: Resources.Emoji_1f4c2,
    emjD1f4c3: Resources.Emoji_1f4c3,
    emjD1f4c4: Resources.Emoji_1f4c4,
    emjD1f4c5: Resources.Emoji_1f4c5,
    emjD1f4c6: Resources.Emoji_1f4c6,
    emjD1f4c7: Resources.Emoji_1f4c7,
    emjD1f4c8: Resources.Emoji_1f4c8,
    emjD1f4c9: Resources.Emoji_1f4c9,
    emjD1f4ca: Resources.Emoji_1f4ca,
    emjD1f4cb: Resources.Emoji_1f4cb,
    emjD1f4cc: Resources.Emoji_1f4cc,
    emjD1f4cd: Resources.Emoji_1f4cd,
    emjD1f4ce: Resources.Emoji_1f4ce,
    emjD1f4cf: Resources.Emoji_1f4cf,
    emjD1f4d0: Resources.Emoji_1f4d0,
    emjD1f4d1: Resources.Emoji_1f4d1,
    emjD1f4d2: Resources.Emoji_1f4d2,
    emjD1f4d3: Resources.Emoji_1f4d3,
    emjD1f4d4: Resources.Emoji_1f4d4,
    emjD1f4d5: Resources.Emoji_1f4d5,
    emjD1f4d6: Resources.Emoji_1f4d6,
    emjD1f4d7: Resources.Emoji_1f4d7,
    emjD1f4d8: Resources.Emoji_1f4d8,
    emjD1f4d9: Resources.Emoji_1f4d9,
    emjD1f4da: Resources.Emoji_1f4da,
    emjD1f4db: Resources.Emoji_1f4db,
    emjD1f4dc: Resources.Emoji_1f4dc,
    emjD1f4dd: Resources.Emoji_1f4dd,
    emjD1f4de: Resources.Emoji_1f4de,
    emjD1f4df: Resources.Emoji_1f4df,
    emjD1f4e0: Resources.Emoji_1f4e0,
    emjD1f4e1: Resources.Emoji_1f4e1,
    emjD1f4e2: Resources.Emoji_1f4e2,
    emjD1f4e3: Resources.Emoji_1f4e3,
    emjD1f4e4: Resources.Emoji_1f4e4,
    emjD1f4e5: Resources.Emoji_1f4e5,
    emjD1f4e6: Resources.Emoji_1f4e6,
    emjD1f4e7: Resources.Emoji_1f4e7,
    emjD1f4e8: Resources.Emoji_1f4e8,
    emjD1f4e9: Resources.Emoji_1f4e9,
    emjD1f4ea: Resources.Emoji_1f4ea,
    emjD1f4eb: Resources.Emoji_1f4eb,
    emjD1f4ee: Resources.Emoji_1f4ee,
    emjD1f4f0: Resources.Emoji_1f4f0,
    emjD1f4f1: Resources.Emoji_1f4f1,
    emjD1f4f2: Resources.Emoji_1f4f2,
    emjD1f4f3: Resources.Emoji_1f4f3,
    emjD1f4f4: Resources.Emoji_1f4f4,
    emjD1f4f6: Resources.Emoji_1f4f6,
    emjD1f525: Resources.Emoji_1f525,
    emjD1f526: Resources.Emoji_1f526,
    emjD1f527: Resources.Emoji_1f527,
    emjD1f528: Resources.Emoji_1f528,
    emjD1f529: Resources.Emoji_1f529,
    emjD1f52a: Resources.Emoji_1f52a,
    emjD1f52b: Resources.Emoji_1f52b,
    emjD1f52e: Resources.Emoji_1f52e,
    emjD1f52f: Resources.Emoji_1f52f,
    emjD1f531: Resources.Emoji_1f531,
    emjD1f550: Resources.Emoji_1f550,
    emjD1f551: Resources.Emoji_1f551,
    emjD1f552: Resources.Emoji_1f552,
    emjD1f553: Resources.Emoji_1f553,
    emjD1f554: Resources.Emoji_1f554,
    emjD1f555: Resources.Emoji_1f555,
    emjD1f556: Resources.Emoji_1f556,
    emjD1f557: Resources.Emoji_1f557,
    emjD1f558: Resources.Emoji_1f558,
    emjD1f559: Resources.Emoji_1f559,
    emjD1f55a: Resources.Emoji_1f55a,
    emjD1f55b: Resources.Emoji_1f55b,
    emjD02668: Resources.Emoji_02668,
    emjD0267f: Resources.Emoji_0267f,
    emjD02693: Resources.Emoji_02693,
    emjD026a0: Resources.Emoji_026a0,
    emjD026a1: Resources.Emoji_026a1,
    emjD026d4: Resources.Emoji_026d4,
    emjD026ea: Resources.Emoji_026ea,
    emjD026f2: Resources.Emoji_026f2,
    emjD026f3: Resources.Emoji_026f3,
    emjD026f5: Resources.Emoji_026f5,
    emjD026fa: Resources.Emoji_026fa,
    emjD026fd: Resources.Emoji_026fd,
    emjD02708: Resources.Emoji_02708,
    emjD1f17f: Resources.Emoji_1f17f,
    emjD1f3e0: Resources.Emoji_1f3e0,
    emjD1f3e1: Resources.Emoji_1f3e1,
    emjD1f3e2: Resources.Emoji_1f3e2,
    emjD1f3e3: Resources.Emoji_1f3e3,
    emjD1f3e5: Resources.Emoji_1f3e5,
    emjD1f3e6: Resources.Emoji_1f3e6,
    emjD1f3e7: Resources.Emoji_1f3e7,
    emjD1f3e8: Resources.Emoji_1f3e8,
    emjD1f3e9: Resources.Emoji_1f3e9,
    emjD1f3ea: Resources.Emoji_1f3ea,
    emjD1f3eb: Resources.Emoji_1f3eb,
    emjD1f3ec: Resources.Emoji_1f3ec,
    emjD1f3ed: Resources.Emoji_1f3ed,
    emjD1f3ee: Resources.Emoji_1f3ee,
    emjD1f3ef: Resources.Emoji_1f3ef,
    emjD1f3f0: Resources.Emoji_1f3f0,
    emjD1f530: Resources.Emoji_1f530,
    emjD1f680: Resources.Emoji_1f680,
    emjD1f683: Resources.Emoji_1f683,
    emjD1f684: Resources.Emoji_1f684,
    emjD1f685: Resources.Emoji_1f685,
    emjD1f687: Resources.Emoji_1f687,
    emjD1f689: Resources.Emoji_1f689,
    emjD1f68c: Resources.Emoji_1f68c,
    emjD1f68f: Resources.Emoji_1f68f,
    emjD1f691: Resources.Emoji_1f691,
    emjD1f692: Resources.Emoji_1f692,
    emjD1f693: Resources.Emoji_1f693,
    emjD1f695: Resources.Emoji_1f695,
    emjD1f697: Resources.Emoji_1f697,
    emjD1f699: Resources.Emoji_1f699,
    emjD1f69a: Resources.Emoji_1f69a,
    emjD1f6a2: Resources.Emoji_1f6a2,
    emjD1f6a4: Resources.Emoji_1f6a4,
    emjD1f6a5: Resources.Emoji_1f6a5,
    emjD1f6a7: Resources.Emoji_1f6a7,
    emjD1f6a8: Resources.Emoji_1f6a8,
    emjD1f6a9: Resources.Emoji_1f6a9,
    emjD1f6aa: Resources.Emoji_1f6aa,
    emjD1f6ab: Resources.Emoji_1f6ab,
    emjD1f6ac: Resources.Emoji_1f6ac,
    emjD1f6ad: Resources.Emoji_1f6ad,
    emjD1f6b2: Resources.Emoji_1f6b2,
    emjD1f6b6: Resources.Emoji_1f6b6,
    emjD1f6b9: Resources.Emoji_1f6b9,
    emjD1f6ba: Resources.Emoji_1f6ba,
    emjD1f6bb: Resources.Emoji_1f6bb,
    emjD1f6bc: Resources.Emoji_1f6bc,
    emjD1f6bd: Resources.Emoji_1f6bd,
    emjD1f6be: Resources.Emoji_1f6be,
    emjD1f6c0: Resources.Emoji_1f6c0,
    emjD02049: Resources.Emoji_02049,
    emjD02139: Resources.Emoji_02139,
    emjD021a9: Resources.Emoji_021a9,
    emjD021aa: Resources.Emoji_021aa,
    emjD0231a: Resources.Emoji_0231a,
    emjD0231b: Resources.Emoji_0231b,
    emjD023e9: Resources.Emoji_023e9,
    emjD023ea: Resources.Emoji_023ea,
    emjD023eb: Resources.Emoji_023eb,
    emjD023ec: Resources.Emoji_023ec,
    emjD023f0: Resources.Emoji_023f0,
    emjD023f3: Resources.Emoji_023f3,
    emjD024c2: Resources.Emoji_024c2,
    emjD025b6: Resources.Emoji_025b6,
    emjD025c0: Resources.Emoji_025c0,
    emjD025fb: Resources.Emoji_025fb,
    emjD025fc: Resources.Emoji_025fc,
    emjD026ce: Resources.Emoji_026ce,
    emjD02611: Resources.Emoji_02611,
    emjD0261d: Resources.Emoji_0261d,
    emjD02648: Resources.Emoji_02648,
    emjD02649: Resources.Emoji_02649,
    emjD0264a: Resources.Emoji_0264a,
    emjD0264b: Resources.Emoji_0264b,
    emjD0264c: Resources.Emoji_0264c,
    emjD0264d: Resources.Emoji_0264d,
    emjD0264e: Resources.Emoji_0264e,
    emjD0264f: Resources.Emoji_0264f,
    emjD02650: Resources.Emoji_02650,
    emjD02651: Resources.Emoji_02651,
    emjD02652: Resources.Emoji_02652,
    emjD02653: Resources.Emoji_02653,
    emjD026aa: Resources.Emoji_026aa,
    emjD026ab: Resources.Emoji_026ab,
    emjD02705: Resources.Emoji_02705,
    emjD02714: Resources.Emoji_02714,
    emjD02716: Resources.Emoji_02716,
    emjD0274c: Resources.Emoji_0274c,
    emjD0274e: Resources.Emoji_0274e,
    emjD02753: Resources.Emoji_02753,
    emjD02754: Resources.Emoji_02754,
    emjD02755: Resources.Emoji_02755,
    emjD02757: Resources.Emoji_02757,
    emjD02795: Resources.Emoji_02795,
    emjD02796: Resources.Emoji_02796,
    emjD02797: Resources.Emoji_02797,
    emjD027a1: Resources.Emoji_027a1,
    emjD027b0: Resources.Emoji_027b0,
    emjD027bf: Resources.Emoji_027bf,
    emjD02934: Resources.Emoji_02934,
    emjD02935: Resources.Emoji_02935,
    emjD02b05: Resources.Emoji_02b05,
    emjD02b06: Resources.Emoji_02b06,
    emjD02b07: Resources.Emoji_02b07,
    emjD02b1b: Resources.Emoji_02b1b,
    emjD02b1c: Resources.Emoji_02b1c,
    emjD02b55: Resources.Emoji_02b55,
    emjD03030: Resources.Emoji_03030,
    emjD0303d: Resources.Emoji_0303d,
    emjD03297: Resources.Emoji_03297,
    emjD03299: Resources.Emoji_03299,
    emjD1f0cf: Resources.Emoji_1f0cf,
    emjD1f170: Resources.Emoji_1f170,
    emjD1f171: Resources.Emoji_1f171,
    emjD1f17e: Resources.Emoji_1f17e,
    emjD1f18e: Resources.Emoji_1f18e,
    emjD1f191: Resources.Emoji_1f191,
    emjD1f192: Resources.Emoji_1f192,
    emjD1f193: Resources.Emoji_1f193,
    emjD1f194: Resources.Emoji_1f194,
    emjD1f195: Resources.Emoji_1f195,
    emjD1f196: Resources.Emoji_1f196,
    emjD1f197: Resources.Emoji_1f197,
    emjD1f198: Resources.Emoji_1f198,
    emjD1f199: Resources.Emoji_1f199,
    emjD1f19a: Resources.Emoji_1f19a,
    emjD1f201: Resources.Emoji_1f201,
    emjD1f202: Resources.Emoji_1f202,
    emjD1f21a: Resources.Emoji_1f21a,
    emjD1f22f: Resources.Emoji_1f22f,
    emjD1f232: Resources.Emoji_1f232,
    emjD1f233: Resources.Emoji_1f233,
    emjD1f234: Resources.Emoji_1f234,
    emjD1f235: Resources.Emoji_1f235,
    emjD1f236: Resources.Emoji_1f236,
    emjD1f237: Resources.Emoji_1f237,
    emjD1f238: Resources.Emoji_1f238,
    emjD1f239: Resources.Emoji_1f239,
    emjD1f23a: Resources.Emoji_1f23a,
    emjD1f250: Resources.Emoji_1f250,
    emjD1f251: Resources.Emoji_1f251,
    emjD1f30f: Resources.Emoji_1f30f,
    emjD1f4a0: Resources.Emoji_1f4a0,
    emjD1f4a1: Resources.Emoji_1f4a1,
    emjD1f4a2: Resources.Emoji_1f4a2,
    emjD1f4a3: Resources.Emoji_1f4a3,
    emjD1f4a4: Resources.Emoji_1f4a4,
    emjD1f4a5: Resources.Emoji_1f4a5,
    emjD1f4a6: Resources.Emoji_1f4a6,
    emjD1f4a7: Resources.Emoji_1f4a7,
    emjD1f4a8: Resources.Emoji_1f4a8,
    emjD1f4a9: Resources.Emoji_1f4a9,
    emjD1f4aa: Resources.Emoji_1f4aa,
    emjD1f4ab: Resources.Emoji_1f4ab,
    emjD1f4ac: Resources.Emoji_1f4ac,
    emjD1f4ae: Resources.Emoji_1f4ae,
    emjD1f4af: Resources.Emoji_1f4af,
    emjD1f4b0: Resources.Emoji_1f4b0,
    emjD1f4b1: Resources.Emoji_1f4b1,
    emjD1f4b2: Resources.Emoji_1f4b2,
    emjD1f4b3: Resources.Emoji_1f4b3,
    emjD1f4b4: Resources.Emoji_1f4b4,
    emjD1f4b5: Resources.Emoji_1f4b5,
    emjD1f4b8: Resources.Emoji_1f4b8,
    emjD1f4b9: Resources.Emoji_1f4b9,
    emjD1f503: Resources.Emoji_1f503,
    emjD1f50a: Resources.Emoji_1f50a,
    emjD1f50b: Resources.Emoji_1f50b,
    emjD1f50c: Resources.Emoji_1f50c,
    emjD1f50d: Resources.Emoji_1f50d,
    emjD1f50e: Resources.Emoji_1f50e,
    emjD1f50f: Resources.Emoji_1f50f,
    emjD1f510: Resources.Emoji_1f510,
    emjD1f511: Resources.Emoji_1f511,
    emjD1f512: Resources.Emoji_1f512,
    emjD1f513: Resources.Emoji_1f513,
    emjD1f514: Resources.Emoji_1f514,
    emjD1f516: Resources.Emoji_1f516,
    emjD1f517: Resources.Emoji_1f517,
    emjD1f518: Resources.Emoji_1f518,
    emjD1f519: Resources.Emoji_1f519,
    emjD1f51a: Resources.Emoji_1f51a,
    emjD1f51b: Resources.Emoji_1f51b,
    emjD1f51c: Resources.Emoji_1f51c,
    emjD1f51d: Resources.Emoji_1f51d,
    emjD1f51e: Resources.Emoji_1f51e,
    emjD1f51f: Resources.Emoji_1f51f,
    emjD1f520: Resources.Emoji_1f520,
    emjD1f521: Resources.Emoji_1f521,
    emjD1f522: Resources.Emoji_1f522,
    emjD1f523: Resources.Emoji_1f523,
    emjD1f524: Resources.Emoji_1f524,
    emjD1f532: Resources.Emoji_1f532,
    emjD1f533: Resources.Emoji_1f533,
    emjD1f534: Resources.Emoji_1f534,
    emjD1f535: Resources.Emoji_1f535,
    emjD1f536: Resources.Emoji_1f536,
    emjD1f537: Resources.Emoji_1f537,
    emjD1f538: Resources.Emoji_1f538,
    emjD1f539: Resources.Emoji_1f539,
    emjD1f53a: Resources.Emoji_1f53a,
    emjD1f53b: Resources.Emoji_1f53b,
    emjD1f53c: Resources.Emoji_1f53c,
    emjD1f53d: Resources.Emoji_1f53d,
    emjD1f5fb: Resources.Emoji_1f5fb,
    emjD1f5fc: Resources.Emoji_1f5fc,
    emjD1f5fd: Resources.Emoji_1f5fd,
    emjD1f5fe: Resources.Emoji_1f5fe,
    emjD1f5ff: Resources.Emoji_1f5ff,

    // Search tags
    emjK1f607: Resources.EmojiSearchTags_1f607,
    emjK1f47c: Resources.EmojiSearchTags_1f47c,
    emjK1f34e: Resources.EmojiSearchTags_1f34e,
    emjK1f34f: Resources.EmojiSearchTags_1f34f,
    emjK1f477: Resources.EmojiSearchTags_1f477,
    emjK1f6a7: Resources.EmojiSearchTags_1f6a7,
    emjK1f491: Resources.EmojiSearchTags_1f491,
    emjK1f46b: Resources.EmojiSearchTags_1f46b,
    emjK1f622: Resources.EmojiSearchTags_1f622,
    emjK1f62d: Resources.EmojiSearchTags_1f62d,
    emjK1f525: Resources.EmojiSearchTags_1f525,
    emjK1f692: Resources.EmojiSearchTags_1f692,
    emjK1f386: Resources.EmojiSearchTags_1f386,
    emjK1f387: Resources.EmojiSearchTags_1f387,
    emjK1f44a: Resources.EmojiSearchTags_1f44a,
    emjK0270a: Resources.EmojiSearchTags_0270a,
    emjK1f498: Resources.EmojiSearchTags_1f498,
    emjK1f496: Resources.EmojiSearchTags_1f496,
    emjK1f497: Resources.EmojiSearchTags_1f497,
    emjK1f493: Resources.EmojiSearchTags_1f493,
    emjK1f368: Resources.EmojiSearchTags_1f368,
    emjK1f366: Resources.EmojiSearchTags_1f366,
    emjK1f48b: Resources.EmojiSearchTags_1f48b,
    emjK1f444: Resources.EmojiSearchTags_1f444,
    emjK1f618: Resources.EmojiSearchTags_1f618,
    emjK1f61a: Resources.EmojiSearchTags_1f61a,
    emjK1f48f: Resources.EmojiSearchTags_1f48f,
    emjK1f435: Resources.EmojiSearchTags_1f435,
    emjK1f64a: Resources.EmojiSearchTags_1f64a,
    emjK1f649: Resources.EmojiSearchTags_1f649,
    emjK1f648: Resources.EmojiSearchTags_1f648,
    emjK1f3b6: Resources.EmojiSearchTags_1f3b6,
    emjK1f3b5: Resources.EmojiSearchTags_1f3b5,
    emjK1f44c: Resources.EmojiSearchTags_1f44c,
    emjK1f646: Resources.EmojiSearchTags_1f646,
    emjK1f621: Resources.EmojiSearchTags_1f621,
    emjK1f64e: Resources.EmojiSearchTags_1f64e,
    emjK1f60c: Resources.EmojiSearchTags_1f60c,
    emjK1f630: Resources.EmojiSearchTags_1f630,
    emjK1f605: Resources.EmojiSearchTags_1f605,
    emjK1f380: Resources.EmojiSearchTags_1f380,
    emjK1f381: Resources.EmojiSearchTags_1f381,
    emjK1f613: Resources.EmojiSearchTags_1f613,
    emjK1f631: Resources.EmojiSearchTags_1f631,
    emjK1f629: Resources.EmojiSearchTags_1f629,
    emjK1f628: Resources.EmojiSearchTags_1f628,
    emjK1f45e: Resources.EmojiSearchTags_1f45e,
    emjK1f45f: Resources.EmojiSearchTags_1f45f,
    emjK1f60a: Resources.EmojiSearchTags_1f60a,
    emjK1f642: Resources.EmojiSearchTags_1f642,
    emjK1f603: Resources.EmojiSearchTags_1f603,
    emjK1f604: Resources.EmojiSearchTags_1f604,
    emjK1f6bd: Resources.EmojiSearchTags_1f6bd,
    emjK1f6ba: Resources.EmojiSearchTags_1f6ba,
    emjK1f6b9: Resources.EmojiSearchTags_1f6b9,
    emjK1f684: Resources.EmojiSearchTags_1f684,
    emjK1f683: Resources.EmojiSearchTags_1f683,
    emjK1f446: Resources.EmojiSearchTags_1f446,
    emjK0261d: Resources.EmojiSearchTags_0261d,
    emjK1f64b: Resources.EmojiSearchTags_1f64b,
    emjK1f44b: Resources.EmojiSearchTags_1f44b,
    emjK1f601: Resources.EmojiSearchTags_1f601,
    emjK1f602: Resources.EmojiSearchTags_1f602,
    emjK1f606: Resources.EmojiSearchTags_1f606,
    emjK1f609: Resources.EmojiSearchTags_1f609,
    emjK1f60f: Resources.EmojiSearchTags_1f60f,
    emjK1f645: Resources.EmojiSearchTags_1f645,
    emjK1f44e: Resources.EmojiSearchTags_1f44e,
    emjK1f60d: Resources.EmojiSearchTags_1f60d,
    emjK1f495: Resources.EmojiSearchTags_1f495,
    emjK1f44d: Resources.EmojiSearchTags_1f44d,
    emjK1f610: Resources.EmojiSearchTags_1f610,
    emjK1f620: Resources.EmojiSearchTags_1f620,
    emjK1f612: Resources.EmojiSearchTags_1f612,
    emjK1f47b: Resources.EmojiSearchTags_1f47b,
    emjK1f480: Resources.EmojiSearchTags_1f480,
    emjK1f47e: Resources.EmojiSearchTags_1f47e,
    emjK1f365: Resources.EmojiSearchTags_1f365,
    emjK1f61e: Resources.EmojiSearchTags_1f61e,
    emjK1f64d: Resources.EmojiSearchTags_1f64d,
    emjK1f494: Resources.EmojiSearchTags_1f494,
    emjK1f625: Resources.EmojiSearchTags_1f625,
    emjK1f62b: Resources.EmojiSearchTags_1f62b,
    emjK1f4a4: Resources.EmojiSearchTags_1f4a4,
    emjK1f62a: Resources.EmojiSearchTags_1f62a,
    emjK1f632: Resources.EmojiSearchTags_1f632,
    emjK1f633: Resources.EmojiSearchTags_1f633,
    emjK1f3c4: Resources.EmojiSearchTags_1f3c4,
    emjK1f44f: Resources.EmojiSearchTags_1f44f,
    emjK1f64c: Resources.EmojiSearchTags_1f64c,
    emjK1f48d: Resources.EmojiSearchTags_1f48d,
    emjK1f483: Resources.EmojiSearchTags_1f483,
    emjK1f389: Resources.EmojiSearchTags_1f389,
    emjK1f388: Resources.EmojiSearchTags_1f388,
    emjK1f38a: Resources.EmojiSearchTags_1f38a,
    emjK1f383: Resources.EmojiSearchTags_1f383,
    emjK1f385: Resources.EmojiSearchTags_1f385,
    emjK1f384: Resources.EmojiSearchTags_1f384,
    emjK1f3eb: Resources.EmojiSearchTags_1f3eb,
    emjK1f392: Resources.EmojiSearchTags_1f392,
    emjK1f41f: Resources.EmojiSearchTags_1f41f,
    emjK1f3a3: Resources.EmojiSearchTags_1f3a3,
    emjK1f3a5: Resources.EmojiSearchTags_1f3a5,
    emjK1f4f9: Resources.EmojiSearchTags_1f4f9,
    emjK1f3a6: Resources.EmojiSearchTags_1f3a6,
    emjK1f3ad: Resources.EmojiSearchTags_1f3ad,
    emjK1f3bc: Resources.EmojiSearchTags_1f3bc,
    emjK1f3b9: Resources.EmojiSearchTags_1f3b9,
    emjK1f3a7: Resources.EmojiSearchTags_1f3a7,
    emjK1f3b7: Resources.EmojiSearchTags_1f3b7,
    emjK1f3ba: Resources.EmojiSearchTags_1f3ba,
    emjK1f3b8: Resources.EmojiSearchTags_1f3b8,
    emjK1f3bb: Resources.EmojiSearchTags_1f3bb,
    emjK1f3ac: Resources.EmojiSearchTags_1f3ac,
    emjK1f48e: Resources.EmojiSearchTags_1f48e,
    emjK1f3be: Resources.EmojiSearchTags_1f3be,
    emjK1f3c8: Resources.EmojiSearchTags_1f3c8,
    emjK1f3bf: Resources.EmojiSearchTags_1f3bf,
    emjK1f3c2: Resources.EmojiSearchTags_1f3c2,
    emjK026c4: Resources.EmojiSearchTags_026c4,
    emjK02744: Resources.EmojiSearchTags_02744,
    emjK1f3c1: Resources.EmojiSearchTags_1f3c1,
    emjK1f3c3: Resources.EmojiSearchTags_1f3c3,
    emjK1f375: Resources.EmojiSearchTags_1f375,
    emjK02615: Resources.EmojiSearchTags_02615,
    emjK1f377: Resources.EmojiSearchTags_1f377,
    emjK1f378: Resources.EmojiSearchTags_1f378,
    emjK1f379: Resources.EmojiSearchTags_1f379,
    emjK1f68c: Resources.EmojiSearchTags_1f68c,
    emjK1f687: Resources.EmojiSearchTags_1f687,
    emjK1f43b: Resources.EmojiSearchTags_1f43b,
    emjK1f43c: Resources.EmojiSearchTags_1f43c,
    emjK1f340: Resources.EmojiSearchTags_1f340,
    emjK1f320: Resources.EmojiSearchTags_1f320,
    emjK1f303: Resources.EmojiSearchTags_1f303,
    emjK1f307: Resources.EmojiSearchTags_1f307,
    emjK1f31f: Resources.EmojiSearchTags_1f31f,
    emjK02747: Resources.EmojiSearchTags_02747,
    emjK1f4b0: Resources.EmojiSearchTags_1f4b0,
    emjK1f4b5: Resources.EmojiSearchTags_1f4b5,
    emjK1f4b4: Resources.EmojiSearchTags_1f4b4,
    emjK1f4b3: Resources.EmojiSearchTags_1f4b3,
    emjK1f60b: Resources.EmojiSearchTags_1f60b,
    emjK1f60e: Resources.EmojiSearchTags_1f60e,
    emjK1f614: Resources.EmojiSearchTags_1f614,
    emjK1f616: Resources.EmojiSearchTags_1f616,
    emjK1f61c: Resources.EmojiSearchTags_1f61c,
    emjK1f61d: Resources.EmojiSearchTags_1f61d,
    emjK1f623: Resources.EmojiSearchTags_1f623,
    emjK1f624: Resources.EmojiSearchTags_1f624,
    emjK1f635: Resources.EmojiSearchTags_1f635,
    emjK1f636: Resources.EmojiSearchTags_1f636,
    emjK1f637: Resources.EmojiSearchTags_1f637,
    emjK1f440: Resources.EmojiSearchTags_1f440,
    emjK1f442: Resources.EmojiSearchTags_1f442,
    emjK1f443: Resources.EmojiSearchTags_1f443,
    emjK1f445: Resources.EmojiSearchTags_1f445,
    emjK1f447: Resources.EmojiSearchTags_1f447,
    emjK1f448: Resources.EmojiSearchTags_1f448,
    emjK1f449: Resources.EmojiSearchTags_1f449,
    emjK1f64f: Resources.EmojiSearchTags_1f64f,
    emjK0270b: Resources.EmojiSearchTags_0270b,
    emjK0270c: Resources.EmojiSearchTags_0270c,
    emjK1f466: Resources.EmojiSearchTags_1f466,
    emjK1f467: Resources.EmojiSearchTags_1f467,
    emjK1f468: Resources.EmojiSearchTags_1f468,
    emjK1f469: Resources.EmojiSearchTags_1f469,
    emjK1f46a: Resources.EmojiSearchTags_1f46a,
    emjK1f46e: Resources.EmojiSearchTags_1f46e,
    emjK1f46f: Resources.EmojiSearchTags_1f46f,
    emjK1f470: Resources.EmojiSearchTags_1f470,
    emjK1f471: Resources.EmojiSearchTags_1f471,
    emjK1f474: Resources.EmojiSearchTags_1f474,
    emjK1f475: Resources.EmojiSearchTags_1f475,
    emjK1f476: Resources.EmojiSearchTags_1f476,
    emjK1f382: Resources.EmojiSearchTags_1f382,
    emjK1f390: Resources.EmojiSearchTags_1f390,
    emjK1f393: Resources.EmojiSearchTags_1f393,
    emjK1f0cf: Resources.EmojiSearchTags_1f0cf,
    emjK1f3a0: Resources.EmojiSearchTags_1f3a0,
    emjK1f3a1: Resources.EmojiSearchTags_1f3a1,
    emjK1f3a2: Resources.EmojiSearchTags_1f3a2,
    emjK1f3a4: Resources.EmojiSearchTags_1f3a4,
    emjK1f3a8: Resources.EmojiSearchTags_1f3a8,
    emjK1f3a9: Resources.EmojiSearchTags_1f3a9,
    emjK1f3aa: Resources.EmojiSearchTags_1f3aa,
    emjK1f3ab: Resources.EmojiSearchTags_1f3ab,
    emjK1f3ae: Resources.EmojiSearchTags_1f3ae,
    emjK1f3af: Resources.EmojiSearchTags_1f3af,
    emjK1f3b0: Resources.EmojiSearchTags_1f3b0,
    emjK1f3b1: Resources.EmojiSearchTags_1f3b1,
    emjK1f3b2: Resources.EmojiSearchTags_1f3b2,
    emjK1f3b3: Resources.EmojiSearchTags_1f3b3,
    emjK1f4f7: Resources.EmojiSearchTags_1f4f7,
    emjK1f4fa: Resources.EmojiSearchTags_1f4fa,
    emjK1f4fb: Resources.EmojiSearchTags_1f4fb,
    emjK1f4fc: Resources.EmojiSearchTags_1f4fc,
    emjK1f478: Resources.EmojiSearchTags_1f478,
    emjK1f47d: Resources.EmojiSearchTags_1f47d,
    emjK1f47f: Resources.EmojiSearchTags_1f47f,
    emjK1f484: Resources.EmojiSearchTags_1f484,
    emjK1f485: Resources.EmojiSearchTags_1f485,
    emjK1f486: Resources.EmojiSearchTags_1f486,
    emjK1f487: Resources.EmojiSearchTags_1f487,
    emjK1f488: Resources.EmojiSearchTags_1f488,
    emjK1f489: Resources.EmojiSearchTags_1f489,
    emjK1f48a: Resources.EmojiSearchTags_1f48a,
    emjK1f48c: Resources.EmojiSearchTags_1f48c,
    emjK1f490: Resources.EmojiSearchTags_1f490,
    emjK1f492: Resources.EmojiSearchTags_1f492,
    emjK1f3c0: Resources.EmojiSearchTags_1f3c0,
    emjK1f3c6: Resources.EmojiSearchTags_1f3c6,
    emjK1f3ca: Resources.EmojiSearchTags_1f3ca,
    emjK026bd: Resources.EmojiSearchTags_026bd,
    emjK026be: Resources.EmojiSearchTags_026be,
    emjK1f451: Resources.EmojiSearchTags_1f451,
    emjK1f453: Resources.EmojiSearchTags_1f453,
    emjK1f454: Resources.EmojiSearchTags_1f454,
    emjK1f455: Resources.EmojiSearchTags_1f455,
    emjK1f456: Resources.EmojiSearchTags_1f456,
    emjK1f457: Resources.EmojiSearchTags_1f457,
    emjK1f459: Resources.EmojiSearchTags_1f459,
    emjK1f45b: Resources.EmojiSearchTags_1f45b,
    emjK1f45c: Resources.EmojiSearchTags_1f45c,
    emjK1f45d: Resources.EmojiSearchTags_1f45d,
    emjK1f461: Resources.EmojiSearchTags_1f461,
    emjK1f462: Resources.EmojiSearchTags_1f462,
    emjK1f463: Resources.EmojiSearchTags_1f463,
    emjK1f4dd: Resources.EmojiSearchTags_1f4dd,
    emjK1f4de: Resources.EmojiSearchTags_1f4de,
    emjK1f4df: Resources.EmojiSearchTags_1f4df,
    emjK1f4e0: Resources.EmojiSearchTags_1f4e0,
    emjK1f4e1: Resources.EmojiSearchTags_1f4e1,
    emjK1f4e3: Resources.EmojiSearchTags_1f4e3,
    emjK1f4e6: Resources.EmojiSearchTags_1f4e6,
    emjK1f4e7: Resources.EmojiSearchTags_1f4e7,
    emjK1f4ee: Resources.EmojiSearchTags_1f4ee,
    emjK1f4f0: Resources.EmojiSearchTags_1f4f0,
    emjK1f4f1: Resources.EmojiSearchTags_1f4f1,
    emjK1f4f6: Resources.EmojiSearchTags_1f4f6,
    emjK1f526: Resources.EmojiSearchTags_1f526,
    emjK1f527: Resources.EmojiSearchTags_1f527,
    emjK1f528: Resources.EmojiSearchTags_1f528,
    emjK1f529: Resources.EmojiSearchTags_1f529,
    emjK1f52a: Resources.EmojiSearchTags_1f52a,
    emjK1f52e: Resources.EmojiSearchTags_1f52e,
    emjK1f531: Resources.EmojiSearchTags_1f531,
    emjK1f354: Resources.EmojiSearchTags_1f354,
    emjK1f355: Resources.EmojiSearchTags_1f355,
    emjK1f356: Resources.EmojiSearchTags_1f356,
    emjK1f357: Resources.EmojiSearchTags_1f357,
    emjK1f35a: Resources.EmojiSearchTags_1f35a,
    emjK1f35c: Resources.EmojiSearchTags_1f35c,
    emjK1f35d: Resources.EmojiSearchTags_1f35d,
    emjK1f35e: Resources.EmojiSearchTags_1f35e,
    emjK1f35f: Resources.EmojiSearchTags_1f35f,
    emjK1f360: Resources.EmojiSearchTags_1f360,
    emjK1f363: Resources.EmojiSearchTags_1f363,
    emjK1f364: Resources.EmojiSearchTags_1f364,
    emjK1f369: Resources.EmojiSearchTags_1f369,
    emjK1f36a: Resources.EmojiSearchTags_1f36a,
    emjK1f36b: Resources.EmojiSearchTags_1f36b,
    emjK1f36c: Resources.EmojiSearchTags_1f36c,
    emjK1f36d: Resources.EmojiSearchTags_1f36d,
    emjK1f36e: Resources.EmojiSearchTags_1f36e,
    emjK1f36f: Resources.EmojiSearchTags_1f36f,
    emjK1f370: Resources.EmojiSearchTags_1f370,
    emjK1f371: Resources.EmojiSearchTags_1f371,
    emjK1f372: Resources.EmojiSearchTags_1f372,
    emjK1f374: Resources.EmojiSearchTags_1f374,
    emjK1f376: Resources.EmojiSearchTags_1f376,
    emjK1f37a: Resources.EmojiSearchTags_1f37a,
    emjK1f37b: Resources.EmojiSearchTags_1f37b,
    emjK1f345: Resources.EmojiSearchTags_1f345,
    emjK1f346: Resources.EmojiSearchTags_1f346,
    emjK1f347: Resources.EmojiSearchTags_1f347,
    emjK1f348: Resources.EmojiSearchTags_1f348,
    emjK1f349: Resources.EmojiSearchTags_1f349,
    emjK1f34a: Resources.EmojiSearchTags_1f34a,
    emjK1f34c: Resources.EmojiSearchTags_1f34c,
    emjK1f34d: Resources.EmojiSearchTags_1f34d,
    emjK1f351: Resources.EmojiSearchTags_1f351,
    emjK1f352: Resources.EmojiSearchTags_1f352,
    emjK1f353: Resources.EmojiSearchTags_1f353,
    emjK1f4ba: Resources.EmojiSearchTags_1f4ba,
    emjK1f4bb: Resources.EmojiSearchTags_1f4bb,
    emjK1f4bc: Resources.EmojiSearchTags_1f4bc,
    emjK1f4be: Resources.EmojiSearchTags_1f4be,
    emjK1f4bf: Resources.EmojiSearchTags_1f4bf,
    emjK1f4c0: Resources.EmojiSearchTags_1f4c0,
    emjK1f4c1: Resources.EmojiSearchTags_1f4c1,
    emjK1f4c5: Resources.EmojiSearchTags_1f4c5,
    emjK1f4cb: Resources.EmojiSearchTags_1f4cb,
    emjK1f4cc: Resources.EmojiSearchTags_1f4cc,
    emjK1f4cd: Resources.EmojiSearchTags_1f4cd,
    emjK1f4ce: Resources.EmojiSearchTags_1f4ce,
    emjK1f4cf: Resources.EmojiSearchTags_1f4cf,
    emjK1f4d2: Resources.EmojiSearchTags_1f4d2,
    emjK1f4d3: Resources.EmojiSearchTags_1f4d3,
    emjK1f4da: Resources.EmojiSearchTags_1f4da,
    emjK1f4db: Resources.EmojiSearchTags_1f4db,
    emjK02702: Resources.EmojiSearchTags_02702,
    emjK02709: Resources.EmojiSearchTags_02709,
    emjK0270f: Resources.EmojiSearchTags_0270f,
    emjK1f3e0: Resources.EmojiSearchTags_1f3e0,
    emjK1f3e1: Resources.EmojiSearchTags_1f3e1,
    emjK1f3e2: Resources.EmojiSearchTags_1f3e2,
    emjK1f3e6: Resources.EmojiSearchTags_1f3e6,
    emjK1f3e7: Resources.EmojiSearchTags_1f3e7,
    emjK1f3e8: Resources.EmojiSearchTags_1f3e8,
    emjK1f3ea: Resources.EmojiSearchTags_1f3ea,
    emjK1f3ec: Resources.EmojiSearchTags_1f3ec,
    emjK1f3ed: Resources.EmojiSearchTags_1f3ed,
    emjK1f3f0: Resources.EmojiSearchTags_1f3f0,
    emjK02668: Resources.EmojiSearchTags_02668,
    emjK02693: Resources.EmojiSearchTags_02693,
    emjK026ea: Resources.EmojiSearchTags_026ea,
    emjK026f2: Resources.EmojiSearchTags_026f2,
    emjK026f3: Resources.EmojiSearchTags_026f3,
    emjK026f5: Resources.EmojiSearchTags_026f5,
    emjK026fd: Resources.EmojiSearchTags_026fd,
    emjK1f6aa: Resources.EmojiSearchTags_1f6aa,
    emjK1f6ac: Resources.EmojiSearchTags_1f6ac,
    emjK1f6ad: Resources.EmojiSearchTags_1f6ad,
    emjK1f6b2: Resources.EmojiSearchTags_1f6b2,
    emjK1f6b6: Resources.EmojiSearchTags_1f6b6,
    emjK1f6c0: Resources.EmojiSearchTags_1f6c0,
    emjK0267f: Resources.EmojiSearchTags_0267f,
    emjK026a0: Resources.EmojiSearchTags_026a0,
    emjK026a1: Resources.EmojiSearchTags_026a1,
    emjK1f680: Resources.EmojiSearchTags_1f680,
    emjK1f68f: Resources.EmojiSearchTags_1f68f,
    emjK1f693: Resources.EmojiSearchTags_1f693,
    emjK1f695: Resources.EmojiSearchTags_1f695,
    emjK1f697: Resources.EmojiSearchTags_1f697,
    emjK1f6a2: Resources.EmojiSearchTags_1f6a2,
    emjK02708: Resources.EmojiSearchTags_02708,
    emjK1f42d: Resources.EmojiSearchTags_1f42d,
    emjK1f42e: Resources.EmojiSearchTags_1f42e,
    emjK1f42f: Resources.EmojiSearchTags_1f42f,
    emjK1f430: Resources.EmojiSearchTags_1f430,
    emjK1f431: Resources.EmojiSearchTags_1f431,
    emjK1f432: Resources.EmojiSearchTags_1f432,
    emjK1f433: Resources.EmojiSearchTags_1f433,
    emjK1f434: Resources.EmojiSearchTags_1f434,
    emjK1f436: Resources.EmojiSearchTags_1f436,
    emjK1f437: Resources.EmojiSearchTags_1f437,
    emjK1f438: Resources.EmojiSearchTags_1f438,
    emjK1f439: Resources.EmojiSearchTags_1f439,
    emjK1f43a: Resources.EmojiSearchTags_1f43a,
    emjK1f341: Resources.EmojiSearchTags_1f341,
    emjK1f344: Resources.EmojiSearchTags_1f344,
    emjK1f308: Resources.EmojiSearchTags_1f308,
    emjK02601: Resources.EmojiSearchTags_02601,
    emjK02614: Resources.EmojiSearchTags_02614,
    emjK02728: Resources.EmojiSearchTags_02728,
    emjK1f4a9: Resources.EmojiSearchTags_1f4a9,
    emjK1f4aa: Resources.EmojiSearchTags_1f4aa,
    emjK02648: Resources.EmojiSearchTags_02648,
    emjK02649: Resources.EmojiSearchTags_02649,
    emjK0264a: Resources.EmojiSearchTags_0264a,
    emjK0264b: Resources.EmojiSearchTags_0264b,
    emjK0264c: Resources.EmojiSearchTags_0264c,
    emjK0264d: Resources.EmojiSearchTags_0264d,
    emjK0264e: Resources.EmojiSearchTags_0264e,
    emjK0264f: Resources.EmojiSearchTags_0264f,
    emjK02650: Resources.EmojiSearchTags_02650,
    emjK02651: Resources.EmojiSearchTags_02651,
    emjK02652: Resources.EmojiSearchTags_02652,
    emjK02653: Resources.EmojiSearchTags_02653,
    emjK1f411: Resources.EmojiSearchTags_1f411,
    emjK1f300: Resources.EmojiSearchTags_1f300,
    emjK1f301: Resources.EmojiSearchTags_1f301,
    emjK1f302: Resources.EmojiSearchTags_1f302,
    emjK1f304: Resources.EmojiSearchTags_1f304,
    emjK1f305: Resources.EmojiSearchTags_1f305,
    emjK1f306: Resources.EmojiSearchTags_1f306,
    emjK1f309: Resources.EmojiSearchTags_1f309,
    emjK1f30a: Resources.EmojiSearchTags_1f30a,
    emjK1f30c: Resources.EmojiSearchTags_1f30c,
    emjK1f311: Resources.EmojiSearchTags_1f311,
    emjK1f313: Resources.EmojiSearchTags_1f313,
    emjK1f314: Resources.EmojiSearchTags_1f314,
    emjK1f315: Resources.EmojiSearchTags_1f315,
    emjK1f319: Resources.EmojiSearchTags_1f319,
    emjK1f31b: Resources.EmojiSearchTags_1f31b,
    emjK1f330: Resources.EmojiSearchTags_1f330,
    emjK1f331: Resources.EmojiSearchTags_1f331,
    emjK1f334: Resources.EmojiSearchTags_1f334,
    emjK1f335: Resources.EmojiSearchTags_1f335,
    emjK1f337: Resources.EmojiSearchTags_1f337,
    emjK1f338: Resources.EmojiSearchTags_1f338,
    emjK1f339: Resources.EmojiSearchTags_1f339,
    emjK1f33a: Resources.EmojiSearchTags_1f33a,
    emjK1f33b: Resources.EmojiSearchTags_1f33b,
    emjK1f33c: Resources.EmojiSearchTags_1f33c,
    emjK1f33d: Resources.EmojiSearchTags_1f33d,
    emjK1f33e: Resources.EmojiSearchTags_1f33e,
    emjK1f33f: Resources.EmojiSearchTags_1f33f,
    emjK1f342: Resources.EmojiSearchTags_1f342,
    emjK1f343: Resources.EmojiSearchTags_1f343,
    emjK1f358: Resources.EmojiSearchTags_1f358,
    emjK1f359: Resources.EmojiSearchTags_1f359,
    emjK1f35b: Resources.EmojiSearchTags_1f35b,
    emjK1f361: Resources.EmojiSearchTags_1f361,
    emjK1f362: Resources.EmojiSearchTags_1f362,
    emjK1f373: Resources.EmojiSearchTags_1f373,
    emjK1f3bd: Resources.EmojiSearchTags_1f3bd,
    emjK1f417: Resources.EmojiSearchTags_1f417,
    emjK1f418: Resources.EmojiSearchTags_1f418,
    emjK1f419: Resources.EmojiSearchTags_1f419,
    emjK1f41a: Resources.EmojiSearchTags_1f41a,
    emjK1f41b: Resources.EmojiSearchTags_1f41b,
    emjK1f41c: Resources.EmojiSearchTags_1f41c,
    emjK1f41d: Resources.EmojiSearchTags_1f41d,
    emjK1f41e: Resources.EmojiSearchTags_1f41e,
    emjK1f420: Resources.EmojiSearchTags_1f420,
    emjK1f421: Resources.EmojiSearchTags_1f421,
    emjK1f422: Resources.EmojiSearchTags_1f422,
    emjK1f423: Resources.EmojiSearchTags_1f423,
    emjK1f425: Resources.EmojiSearchTags_1f425,
    emjK1f40c: Resources.EmojiSearchTags_1f40c,
    emjK1f40d: Resources.EmojiSearchTags_1f40d,
    emjK1f40e: Resources.EmojiSearchTags_1f40e,
    emjK1f412: Resources.EmojiSearchTags_1f412,
    emjK1f414: Resources.EmojiSearchTags_1f414,
    emjK1f429: Resources.EmojiSearchTags_1f429,
    emjK1f42b: Resources.EmojiSearchTags_1f42b,
    emjK1f426: Resources.EmojiSearchTags_1f426,
    emjK1f427: Resources.EmojiSearchTags_1f427,
    emjK1f42c: Resources.EmojiSearchTags_1f42c,
    emjK1f43d: Resources.EmojiSearchTags_1f43d,
    emjK1f43e: Resources.EmojiSearchTags_1f43e,
    emjK1f452: Resources.EmojiSearchTags_1f452,
    emjK1f458: Resources.EmojiSearchTags_1f458,
    emjK1f45a: Resources.EmojiSearchTags_1f45a,
    emjK1f481: Resources.EmojiSearchTags_1f481,
    emjK1f482: Resources.EmojiSearchTags_1f482,
    emjK1f499: Resources.EmojiSearchTags_1f499,
    emjK1f49a: Resources.EmojiSearchTags_1f49a,
    emjK1f49b: Resources.EmojiSearchTags_1f49b,
    emjK1f49c: Resources.EmojiSearchTags_1f49c,
    emjK1f49d: Resources.EmojiSearchTags_1f49d,
    emjK1f49e: Resources.EmojiSearchTags_1f49e,
    emjK1f49f: Resources.EmojiSearchTags_1f49f,
    emjK1f4a5: Resources.EmojiSearchTags_1f4a5,
    emjK1f4a3: Resources.EmojiSearchTags_1f4a3,
    emjK1f4a1: Resources.EmojiSearchTags_1f4a1,
    emjK1f4a8: Resources.EmojiSearchTags_1f4a8,
    emjK1f503: Resources.EmojiSearchTags_1f503,
    emjK1f50c: Resources.EmojiSearchTags_1f50c,
    emjK1f50b: Resources.EmojiSearchTags_1f50b,
    emjK1f50d: Resources.EmojiSearchTags_1f50d,
    emjK1f510: Resources.EmojiSearchTags_1f510,
    emjK1f50f: Resources.EmojiSearchTags_1f50f,
    emjK1f511: Resources.EmojiSearchTags_1f511,
    emjK1f512: Resources.EmojiSearchTags_1f512,
    emjK1f513: Resources.EmojiSearchTags_1f513,
    emjK1f516: Resources.EmojiSearchTags_1f516,
    emjK1f514: Resources.EmojiSearchTags_1f514,
    emjK1f550: Resources.EmojiSearchTags_1f550,
    emjK1f551: Resources.EmojiSearchTags_1f551,
    emjK1f552: Resources.EmojiSearchTags_1f552,
    emjK1f553: Resources.EmojiSearchTags_1f553,
    emjK1f554: Resources.EmojiSearchTags_1f554,
    emjK1f555: Resources.EmojiSearchTags_1f555,
    emjK1f556: Resources.EmojiSearchTags_1f556,
    emjK1f557: Resources.EmojiSearchTags_1f557,
    emjK1f558: Resources.EmojiSearchTags_1f558,
    emjK1f559: Resources.EmojiSearchTags_1f559,
    emjK1f55a: Resources.EmojiSearchTags_1f55a,
    emjK1f55b: Resources.EmojiSearchTags_1f55b,
    emjK1f5fd: Resources.EmojiSearchTags_1f5fd,
    emjK1f638: Resources.EmojiSearchTags_1f638,
    emjK1f639: Resources.EmojiSearchTags_1f639,
    emjK1f63a: Resources.EmojiSearchTags_1f63a,
    emjK1f63b: Resources.EmojiSearchTags_1f63b,
    emjK1f63c: Resources.EmojiSearchTags_1f63c,
    emjK1f63d: Resources.EmojiSearchTags_1f63d,
    emjK1f63e: Resources.EmojiSearchTags_1f63e,
    emjK1f63f: Resources.EmojiSearchTags_1f63f,
    emjK1f4e8: Resources.EmojiSearchTags_1f4e8,
    emjK1f4e9: Resources.EmojiSearchTags_1f4e9,
    emjK1f4eb: Resources.EmojiSearchTags_1f4eb,
    emjK1f4ea: Resources.EmojiSearchTags_1f4ea,
    emjK1f6bb: Resources.EmojiSearchTags_1f6bb,
    emjK1f6a5: Resources.EmojiSearchTags_1f6a5,
    emjK1f6ab: Resources.EmojiSearchTags_1f6ab,
    emjK1f689: Resources.EmojiSearchTags_1f689,
    emjK1f69a: Resources.EmojiSearchTags_1f69a,
    emjK026fa: Resources.EmojiSearchTags_026fa,
    emjK1f6a8: Resources.EmojiSearchTags_1f6a8,
    emjK1f17f: Resources.EmojiSearchTags_1f17f,
    emjK02733: Resources.EmojiSearchTags_02733,
    emjK02734: Resources.EmojiSearchTags_02734,
    emjK02b50: Resources.EmojiSearchTags_02b50,
    emjK1f4c8: Resources.EmojiSearchTags_1f4c8,
    emjK1f4c9: Resources.EmojiSearchTags_1f4c9,
    emjK1f4ca: Resources.EmojiSearchTags_1f4ca,
    emjK02764: Resources.EmojiSearchTags_02764
};
